import { Button, Container, Image, Row } from 'react-bootstrap';
import Background from 'assets/img/landing/getStartedBG.png';
import BookDemoModal from 'components/modals/BookDemoModal';
import { useState } from 'react';

function StartToday() {
  const [show, setShow] = useState(false);
  return (
    <Container fluid>
      <Row className="getStarted mb-14 d-flex flex-column justify-content-center align-items-center">
        <BookDemoModal show={show} onClose={() => setShow(false)} />
        <Image
          src={Background}
          alt="bgImage"
          width="100%"
          height="100%"
          className="position-relative"
        />
        <div className="position-absolute w-fit text-center">
          <p className="fs-4 fw-bold text-white">Get Started Today</p>
          <p className="fs-8 text-white m-0">
            Ready to transform hiring, training, and career preparation? Choose
            the path that
          </p>
          <p className="fs-8 text-white mb-5">
            fits your needs and let CRUD Beat guide you to success.
          </p>
          <Button className="py-3" onClick={() => setShow(true)}>
            Book Demo
          </Button>
        </div>
      </Row>
    </Container>
  );
}

export default StartToday;
